// Přepínač CZ ↔ SK v topbaru (countrySwitch.js). Řádek v menu a odkaz v patičce
// nesou `sisterShop.label` z manifestu shopu.
export default {
  /** aria-label přepínače (čtečka slyší jen odkaz na druhý shop) */
  nav: 'E-shop v jiné zemi',
  /** název země podle kódu `shop.country` manifestu: titulek a aria-label vlajky */
  names: {
    CZ: 'Česko',
    SK: 'Slovensko',
  },
};
